import React from 'react'
import { getImageUrl } from 'utils/assets/Cdn'
// eslint-disable-next-line no-restricted-imports
import seedParanaLogo from 'images/logos/logo-seed-parana.svg'
// eslint-disable-next-line no-restricted-imports
import biblioSpLogo from 'images/logos/logo-bibliosp.svg'
import {
  HeaderMobileWrapper,
  HeaderMobileTitleWrapper,
  HeaderMobileContentWrapper,
  HeaderMobileIconProfileWrapper,
  HeaderMobileMenuButton,
  HeaderMobileLeftGroup
} from './HeaderMobile.styles'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { useHistory, useLocation } from 'react-router-dom'
import { useAdminSidebarStore } from 'stores/adminSidebarStore'
import {
  COMUNICAR_HOME_ROOT_PATH,
  LER_HOME_ROOT_PATH,
  LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
  LER_NOTICIAS_HOME_ROOT_PATH,
  ROOT_PATH,
  USER_PROFILE_MENU,
  ACTIVITIES_PATH,
  ATUALIDADES_HOME_ROOT_PATH,
  EXPLORE_PATH,
  FOREST_PATH,
  INGLES_HOME_ROOT_PATH,
  LIVROS_HOME_ROOT_PATH,
  MY_READINGS_MODULAR_PATH,
  LER_NEWSSTAND_ROOT_PATH,
  SENTIR_HOME_ROOT_PATH,
  SENTIR_DIARIO_HOME_ROOT_PATH,
  ADMIN_ROOT_PATH_MOBILE
} from 'routes/paths'
import { useTranslation } from 'i18n'
import type { HeaderMobileProps } from './HeaderMobile.types'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'
import NotificationBell from 'features/user-notifications/components/notification-bell'

const HeaderMobile: React.FC<HeaderMobileProps> = ({ title, pathGoBack }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { user } = useUserInfo()
  const { featureToggles } = useFeatureToggles()
  const { toggle: toggleAdminSidebar } = useAdminSidebarStore()
  const canAccessStoryTree = user?.featureToggles?.storyTree
  const hasBiblionGeneral = featureToggles?.biblionGeneral
  const hasSeedParanaGeneral = featureToggles?.seedParanaGeneral
  const hasBiblioSpGeneral = featureToggles?.biblioSpGeneral
  const arvoreLogo = hasSeedParanaGeneral
    ? seedParanaLogo
    : hasBiblioSpGeneral
    ? biblioSpLogo
    : hasBiblionGeneral
    ? 'https://cdn.arvore.com.br/files.arvoredelivros.com.br/arvore-library-assets/images/biblion/logo-biblion.svg'
    : getImageUrl(
        canAccessStoryTree
          ? 'story-tree/story-tree-logo.svg'
          : 'logos/logo-livros-horizontal.svg'
      )
  const arvoreLogoAlt = hasSeedParanaGeneral
    ? t('Logo da SEED Paraná')
    : hasBiblioSpGeneral
    ? t('Logo da BiblioSP Digital')
    : hasBiblionGeneral
    ? t('Logo do Biblion')
    : canAccessStoryTree
    ? t('Logo do Story Tree')
    : t('Logo da Árvore')
  const currentPath = history?.location.pathname
  const isAdminRoute = location.pathname.includes('/admin')

  const handleGoBack = () => {
    if (history.location.key) {
      history.goBack()
      return
    }
    const fallbackPath = pathGoBack ?? ROOT_PATH
    if (fallbackPath.startsWith('/app-v2')) {
      window.location.assign(fallbackPath)
      return
    }
    history.push(fallbackPath)
  }

  const modularHomeSubDomains = [
    LIVROS_HOME_ROOT_PATH,
    ATUALIDADES_HOME_ROOT_PATH,
    INGLES_HOME_ROOT_PATH,
    SENTIR_HOME_ROOT_PATH,
    SENTIR_DIARIO_HOME_ROOT_PATH,
    LER_HOME_ROOT_PATH,
    LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH,
    LER_NOTICIAS_HOME_ROOT_PATH,
    COMUNICAR_HOME_ROOT_PATH
  ]
  const defaultFooterMenuSubdomains = [
    EXPLORE_PATH,
    FOREST_PATH,
    MY_READINGS_MODULAR_PATH,
    ACTIVITIES_PATH,
    LER_NEWSSTAND_ROOT_PATH,
    ADMIN_ROOT_PATH_MOBILE
  ]

  const isHomePageActive = modularHomeSubDomains.some(subDomain => {
    return currentPath === subDomain
  })
  const isFooterMenuActive = defaultFooterMenuSubdomains.some(
    subDomain => currentPath === subDomain
  )

  return (
    <HeaderMobileWrapper>
      <HeaderMobileContentWrapper>
        <HeaderMobileLeftGroup>
          {isAdminRoute && (
            <HeaderMobileMenuButton
              data-testid="button-menu"
              aria-label="Menu"
              onClick={toggleAdminSidebar}
            >
              <FontIcon iconName="menu" size={24} color={tokens.colors.dark6} />
            </HeaderMobileMenuButton>
          )}
          {!isHomePageActive ? (
            <HeaderMobileTitleWrapper>
              {!isFooterMenuActive && (
                <FontIcon
                  iconName="arrow-left"
                  data-testid="button-back"
                  size={24}
                  color={tokens.colors.dark6}
                  onClick={handleGoBack}
                />
              )}
              <p aria-label={t(title)}>{t(title)}</p>
            </HeaderMobileTitleWrapper>
          ) : (
            <img src={arvoreLogo} alt={arvoreLogoAlt} width="150" height="24" />
          )}
        </HeaderMobileLeftGroup>
        <div className="absolute right-4 flex items-center gap-1">
          {featureToggles?.customNotifications && !hasBiblionGeneral && (
            <NotificationBell />
          )}
          <HeaderMobileIconProfileWrapper
            data-testid="avatar"
            onClick={() => history.push(USER_PROFILE_MENU)}
          >
            <FontIcon iconName="user" size={14} color={tokens.colors.white} />
          </HeaderMobileIconProfileWrapper>
        </div>
      </HeaderMobileContentWrapper>
    </HeaderMobileWrapper>
  )
}

export default HeaderMobile
